import { useEffect, useState } from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminUsers() {
    const [tab, setTab] = useState("respondent");
    const [items, setItems] = useState([]);

    const load = () => {
        api.get(`/admin/users?role=${tab}`).then((r) => setItems(r.data || []));
    };
    useEffect(load, [tab]);

    const approve = async (uid) => {
        await api.post(`/admin/users/${uid}/approve`);
        toast.success("Approved");
        load();
    };
    const reject = async (uid) => {
        const reason = prompt("Reason for rejection?") || "";
        await api.post(`/admin/users/${uid}/reject`, { approve: false, feedback: reason });
        toast.success("Rejected");
        load();
    };
    const suspend = async (uid) => {
        const reason = prompt("Reason for suspension?") || "";
        await api.post(`/admin/users/${uid}/suspend`, { approve: false, feedback: reason });
        toast.success("Suspended");
        load();
    };

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-7xl mx-auto px-6 py-12">
                <p className="eyebrow mb-2">ADMIN · ACCOUNTS</p>
                <h1 className="h2 mb-8">Users & advertisers</h1>
                <div className="flex gap-2 mb-6">
                    {["respondent", "advertiser", "admin"].map((r) => (
                        <button key={r} onClick={() => setTab(r)} className={`btn ${tab === r ? "btn-ink" : "btn-outline"} text-sm py-2 px-4`} data-testid={`tab-${r}`}>
                            {r.charAt(0).toUpperCase() + r.slice(1)}s
                        </button>
                    ))}
                </div>
                <div className="card-base overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-cream">
                            <tr>
                                <Th>Name</Th><Th>Email</Th><Th>Country</Th><Th>Status</Th><Th>Created</Th><Th>Actions</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((u) => (
                                <tr key={u.id} className="border-t border-ink-200" data-testid={`user-row-${u.id}`}>
                                    <Td>{u.name}{u.advertiser_company?.name ? <div className="text-xs text-ink-600">{u.advertiser_company.name}</div> : null}</Td>
                                    <Td>{u.email}</Td>
                                    <Td>{u.country}</Td>
                                    <Td><StatusTag status={u.status} /></Td>
                                    <Td>{new Date(u.created_at).toLocaleDateString()}</Td>
                                    <Td>
                                        <div className="flex flex-wrap gap-2">
                                            {u.status === "pending" && (
                                                <>
                                                    <button className="btn btn-ink text-xs py-1 px-2" onClick={() => approve(u.id)} data-testid={`approve-${u.id}`}>Approve</button>
                                                    <button className="btn btn-outline text-xs py-1 px-2" onClick={() => reject(u.id)} data-testid={`reject-${u.id}`}>Reject</button>
                                                </>
                                            )}
                                            {u.status === "approved" && u.role !== "admin" && (
                                                <button className="btn btn-outline text-xs py-1 px-2 text-error border-error" onClick={() => suspend(u.id)} data-testid={`suspend-${u.id}`}>Suspend</button>
                                            )}
                                        </div>
                                    </Td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr><td colSpan={6} className="text-center p-8 text-ink-600">No users.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </main>
            <Footer />
        </div>
    );
}

const Th = ({ children }) => <th className="text-left px-4 py-3 text-xs uppercase tracking-wider text-ink-600">{children}</th>;
const Td = ({ children }) => <td className="px-4 py-3 align-top">{children}</td>;

function StatusTag({ status }) {
    const map = {
        pending: "bg-warning/15 text-warning",
        approved: "bg-success/15 text-success",
        rejected: "bg-error/15 text-error",
        suspended: "bg-error/15 text-error",
    };
    return <span className={`font-mono text-[10px] px-2 py-1 ${map[status] || "bg-ink-100"}`}>{status?.toUpperCase()}</span>;
}
